export function getOrdinalDate (millisDate) {
  let date = new Date(millisDate)
  let options = {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC'
  }
  let day = date.getUTCDate()
  let ordinalSuffix = ''

  switch (day % 10) {
    case 1: ordinalSuffix = 'st'; break
    case 2: ordinalSuffix = 'nd'; break
    case 3: ordinalSuffix = 'rd'; break
    default: ordinalSuffix = 'th'; break
  }

  if (day > 3 && day < 21) ordinalSuffix = 'th'

  date = date.toLocaleDateString('en-us', options) + ordinalSuffix
  return date
}

export function getDateFromMillis (millisDate) {
  let date = new Date(millisDate)
  let options = {
    month: 'long',
    day: 'numeric'
  }
  let day = date.getDate()
  let ordinalSuffix = ''

  switch (day % 10) {
    case 1: ordinalSuffix = 'st'; break
    case 2: ordinalSuffix = 'nd'; break
    case 3: ordinalSuffix = 'rd'; break
    default: ordinalSuffix = 'th'; break
  }

  if (day > 3 && day < 21) ordinalSuffix = 'th'

  date = date.toLocaleDateString('en-us', options) + ordinalSuffix
  return date
}



// WEBPACK FOOTER //
// ./src/components/shared/enums/date-parser.js